import axios from 'axios';
import { config } from '../../Config';
import { getAgentePayload } from '../../utils/getAgentePayload';

export const baseURL = config.url.apiEndPoint;

const api = axios.create({
  baseURL: process.env.PLATAFORMA_BACKEND_URL || baseURL,
});

export async function listDistribuidoras() {
  try {
    const response = await axios.get(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/claro/simulacao/parametro/list?q=ewogICAgIlBhZ2VOdW1iZXIiOiAxLAogICAgIlBhZ2VTaXplIjogOTk5OTk5LAogICAgImZpbHRlciI6IHsKICAgICAgICAiaWRTaW11bGFkb3JUaXBvIjogNwogICAgfQp9`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );    

    return response.data;
  } catch (error) {
    console.error('Erro ao listar distribuidoras:', error);
    throw error;
  }
}

export async function simularEconomia(data) {
  const agentePayload = getAgentePayload();
  const hasAgente = Boolean(agentePayload.agenteId);

  try {
    data = {
      ...config.simulacao,
      ...data,
      tipoCanal: hasAgente ? config.simulacao.tipoCanalVendedor : config.simulacao.tipoCanal,
    };

    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/claro/simulacao/landingpage/lead/obter`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Erro ao simular economia:', error);
    throw error;
  }
}

export async function consultaCreditScore(payload) {
  const res = await fetch(`${config.url.apiEndPoint}/claro/score/validar`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    throw new Error("Falha ao consultar credit score");
  }

  return res.json();
}


export async function verificarLeadCadastrado(token) {
  try {
    if (!token) throw new Error("Token vazio");

    const apiBase = process.env.PLATAFORMA_BACKEND_URL || baseURL

    const url = `${apiBase}/claro/lead/hash/${encodeURIComponent(token)}`;

    const response = await axios.get(url);
    return response.data?.entities?.Hash;
  } catch (error) {
    console.error("Erro ao obter lead:", error);
    throw error;
  }
}

export async function sendNextStep({ hash, situacao }) {
  try {
    const data = {
      "hash": hash,
      "situacao": situacao
    }

    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/claro/lead/status`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(`Erro ao trocar para etapa ${situacao}`, error);
    throw error;
  }
}

export const handleRedirectPortal = (hash) => {
  if (!hash) return;
  const baseUrl = `${config.url.urlPortal}/claro/aquisicao/${hash}`;
  window.location.assign(baseUrl)
}

export async function verifyOtp(data) {
  try {
    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/claro/auth/otp/verify`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function requestOtp(data) {
  try {
    const response = await axios.post(
      `${
        process.env.PLATAFORMA_BACKEND_URL || baseURL
      }/claro/auth/otp`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
}

export async function obterPreCadastroPorTokenClaro(tokenClaro) {
  const url = `https://hclaro.acessoenergia.com.br/api/claro/energyAccountRegistration/obter/${encodeURIComponent(
    tokenClaro
  )}`;

  const resp = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
    },
  });

  if (!resp.ok) {
    const text = await resp?.text().catch(() => "");
    throw new Error(`Falha ao obter pré-cadastro (${resp.status}): ${text}`);
  }

  return resp.json();
}



export default api;
